import { render, staticRenderFns } from "./ReqDevTimeAverage.vue?vue&type=template&id=ab70fb0a&scoped=true"
import script from "./ReqDevTimeAverage.vue?vue&type=script&lang=js"
export * from "./ReqDevTimeAverage.vue?vue&type=script&lang=js"
import style0 from "./ReqDevTimeAverage.vue?vue&type=style&index=0&id=ab70fb0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab70fb0a",
  null
  
)

export default component.exports